<template>
    <v-btn id="show-candidates-button"
           v-if="!isGuest"
           @click="onClick"
           content="Candidates"
           v-tippy="{placement: 'left'}"
           :class="{'animation-flash': addingCandidateAnimation}"
    >
        <i class="material-symbols-outlined">auto_awesome_motion</i>
        <CandidateCounter />
    </v-btn>
</template>

<script>
import CandidateCounter from "@/components/app/candidates/CandidateCounter.vue";
import { mapGetters, mapState } from "vuex";

export default {
    components: {CandidateCounter},
    computed: {
        ...mapGetters('User', ['isGuest']),
        ...mapState("UI", ['addingCandidateAnimation']),
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setRightColumn', 'candidates')
        },
    },
};
</script>

<style lang="scss" scoped>
#show-candidates-button {
    overflow: visible;
    &.animation-flash {
        animation: button-flash 1s infinite ease-in-out;
    }
}
</style>
